import {whenAppears} from "./whenAppears.js";
// import arrive from 'arrive';
import googleChart from '../components/extras/googleChart';
import Vue from 'vue';

export const fcwp_chart = function(vue_instance) {

    whenAppears(".fcwp-map-outer", async function(element) {

        var url = `${vue_instance.url}/api/fcwp/v1/fcwp-chart/?type=${element.getAttribute('id')}`;
        var map_div = element.querySelector('.fcwp-map');
        var loader_div = element.querySelector('.fcwp-map-loader');
        var error_div = element.querySelector('.fcwp-map-error');
        var description_div = element.querySelector('.fcwp-map-description');
        var options_ul = element.querySelector('.fcwp-map-options');
        var active = 'default';

        var data = await getData(url, loader_div, error_div);

        if (data.error === true) {
            console.log(data.error_txt);
            loader_div.style.opacity = 0;
            error_div.style.opacity = 1;
            return;
        }

        if (data.description && data.items) {
            element.getElementsByClassName('fcwp-map-wrapper')[0].style.paddingBottom = data.height + '%';
            var colors = getColors();
            var googleChartClass = Vue.extend(googleChart);
            var chart = {
                chartType: data.type,
                chartData: data.items,
                chartOptions: data.settings,
            }

            if (typeof chart.chartOptions.sizeAxis != 'undefined') {
                chart.chartOptions.sizeAxis.minSize = window.innerWidth / chart.chartOptions.sizeAxis.min;
                chart.chartOptions.sizeAxis.maxSize = window.innerWidth / chart.chartOptions.sizeAxis.max;
            }
            chart.chartOptions.backgroundColor = colors.background;
            chart.chartOptions.datalessRegionColor = colors.background;
            if (typeof chart.chartOptions.colorAxis != 'undefined' && chart.chartOptions.colorAxis.colors == null) {
                chart.chartOptions.colorAxis.colors = [colors.bubblesSmall, colors.bubblesBig];
            }

            var instance = new googleChartClass({
                data() {
                    return chart;
                }

            });

            instance.$mount();
            map_div.appendChild(instance.$el);

            description_div.innerHTML = data.description;
            options_ul.innerHTML = getOptions(data.options, active);
            description_div.style.opacity = 1;
            map_div.style.opacity = 1;
            loader_div.style.opacity = 0;

            // gdy kontrast lub greyscale
            vue_instance.$root.$on("emitAccesibility", function(e) {
                setTimeout(function(){
                    colors = getColors();
                    instance.chartOptions.backgroundColor = colors.background;
                    instance.chartOptions.datalessRegionColor = colors.background;
                    instance.chartOptions.colorAxis.colors = [colors.bubblesSmall, colors.bubblesBig];
                }, 50);
            });

            //gdy window resize
            window.addEventListener('resize', function() {
                instance.chartOptions.sizeAxis.minSize = window.innerWidth / chart.chartOptions.sizeAxis.min;
                instance.chartOptions.sizeAxis.maxSize = window.innerWidth / chart.chartOptions.sizeAxis.max;
            });

            // gdy  kliknięto opcję
            var options_lis = options_ul.getElementsByTagName('li');
            for (var option_li of options_lis) {
                option_li.onclick = async function() {

                    // loader_div.style.display = 'block';
                    // error_div.style.display = 'block';
                    loader_div.style.opacity = 1;
                    map_div.style.opacity = 0;

                    options_ul.getElementsByClassName('active')[0].classList.remove('active');
                    this.classList.add('active');
                    var new_url = this.id == 'default' ? url : url + '&option=' + this.id;

                    var data = await getData(new_url, loader_div, error_div);

                    if (data.error === true) {
                        console.log(data.error_txt);
                        loader_div.style.opacity = 0;
                        error_div.style.opacity = 1;
                        return;
                    }

                    if (data.description && data.items) {
                        instance.chartData = data.items;
                        description_div.innerHTML = data.description;
                        description_div.style.opacity = 1;
                        map_div.style.opacity = 1;
                        loader_div.style.opacity = 0;
                    }
                }
            }

        }

        function getOptions(options, active) {
            var content = ''
            for (var op of options) {
                content += '<li' + (op.option == active ? ' class="active"' : '') + ' id="' + op.option + '">' + op.name + '</li>';
            }
            return content;
        }

        function getColors() {
            return {
                background:     rgbToHex(getComputedStyle(document.getElementById('app')).getPropertyValue('--color-tertiary')),
                bubblesSmall:   rgbToHex(getComputedStyle(document.getElementById('app')).getPropertyValue('--color-tertiary')),
                bubblesBig:     rgbToHex(getComputedStyle(document.getElementById('app')).getPropertyValue('--color-secondary')),
            }
        }

        function rgbToHex(color_string) { 
            var color_arr = color_string.split(',');
            var r = parseInt(color_arr[0].trim());
            var g = parseInt(color_arr[1].trim());
            var b = parseInt(color_arr[2].trim());
            return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
        }

        async function getData(url, loader_div, error_div) {
            return axios({
                method: 'get',
                url: url
            }).then(function (response) {
                var track_data = {
                    'action': 'see map',
                    'category': 'fcwp_data',
                    'label': response.data.description,
                }
                window.tracker.track(track_data, 'event');
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
                loader_div.style.opacity = 0;
                error_div.style.opacity = 1;
                return;
            })
        }
    });


}